// Reusable Framer Motion variants. Used across every template per design spec §0.8.

import type { Variants } from 'framer-motion';

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24, filter: 'blur(8px)' },
  show: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
  },
  exit: {
    opacity: 0,
    y: -16,
    filter: 'blur(6px)',
    transition: { duration: 0.4, ease: [0.4, 0, 1, 1] },
  },
};

export const stagger = (delay = 0.08): Variants => ({
  show: { transition: { staggerChildren: delay, delayChildren: 0.1 } },
});

export const orbSpring = {
  type: 'spring' as const,
  stiffness: 220,
  damping: 30,
  mass: 0.8,
};
